import React from "react";
import ReactDOM from "react-dom/client";
import UrlFormatter from "../../../app/formatters/UrlFormatter";
import _ from "lodash";

/** @typedef {import('../models/RpaActivityModel.js').RpaActivityItem } RpaActivityItem */

/**
 * @typedef {object} RpaActivitiesProps
 * @property {string} lang - Langue Gestiaweb
 * @property {string} source - Source PWA ou pas
 * @property {Array<RpaActivityItem>} rpaActivities - Liste des activités RPA
 */

class RpaActivities extends React.Component {
  /**
   * @param {RpaActivitiesProps} props
   */
  constructor(props) {
    super(props);

    this.state = /** @type {RpaActivitiesProps} */ ({
      source: props.source === "" ? null : props.source,
      lang: props.lang === "" ? null : props.lang,
      rpaActivities: /** @type {Array<RpaActivityItem>} */ ([])
    });
  }

  async componentDidMount() {
    var rpaActivities = await this.fetchRpaActivities();

    return this.setState({ rpaActivities });
  }

  /**
   * Permet de récupérer la liste des activités
   * @returns {Promise<Array<RpaActivityItem>>} - Objet du planning RPA
   */
  async fetchRpaActivities() {
    var apiUrl = `/api/rpa/search/activities`,
      response = await fetch(apiUrl, {
        headers: {
          Authorization: "gestiaweb"
        }
      });

    return await response.json();
  }

  /**
   * Clic sur une activité lorsque le mode resa step by step est activé
   * @param {RpaActivityItem} rpaActivity - Activité
   */
  onClickOnRpaActivity(rpaActivity) {
    var currentPath = window.location.pathname + window.location.search + window.location.hash,
      url = UrlFormatter.addUrlLangAndSource(`/rpa/index?rpaActivityId=${rpaActivity.id}&returnurl=${encodeURIComponent(currentPath)}`, this.state.lang, this.state.source);

    document.location.href = url;
  }

  render() {
    return (
      <div className="rpaactivities">
        {this.state.rpaActivities.map((rpaActivity, index) => (
          <div key={index} className="rpaactivities__link" style={{ backgroundImage: `url(${rpaActivity.thumbnail})` }} onClick={this.onClickOnRpaActivity.bind(this, rpaActivity)}>
            <h4 className="rpaactivities__title" onClick={this.onClickOnRpaActivity.bind(this, rpaActivity)}>
              {rpaActivity.name}
            </h4>
            {rpaActivity.description ? <p className="rpaactivities__description">{rpaActivity.description}</p> : ""}
          </div>
        ))}
      </div>
    );
  }
}

var rpaActivitiesNode = document.getElementById("rpa-activities");
if (rpaActivitiesNode) {
  var root = ReactDOM.createRoot(rpaActivitiesNode);
  root.render(<RpaActivities source={rpaActivitiesNode.getAttribute("data-source")} lang={rpaActivitiesNode.getAttribute("data-lang")} />);
}
